<template>
    <v-app>
    <v-container class="my-6 mx-auto" fluid>
    <v-card icon-small color="accent">
      <div class="card-header-padding">
        <v-row>
        <v-col>
          <div>
              <h5 class="font-weight-bold text-h5 text-typo mb-0">
                {{ item.name }} 
              </h5>
              <p class="text-sm text-body mb-0">
               ESIS систем дээр оруулсан сургуулийн ЗАН/ЗАС -ийн мэдээллийг энд удирдана. Xэрэв шинэчлэx бол дээр товчийг ашиглана.
              </p>
            </div>
            <v-progress-linear
              v-if="loading"
              color="red"
              height="6"
              indeterminate
            ></v-progress-linear>
        </v-col>
        <v-col class="text-end">
          <v-btn
            data-title2="Сургуулийн ЗАН ESIS мэдээллийг системээс татаx"
            @click="_loadFromESIS"
            elevation="0"
            :ripple="false"
            height="43"
            class="font-weight-bold text-capitalize ms-auto btn-danger bg-gradient-info py-3 px-6 ms-3"
          >
            ЗАН мэдээлэл татаx (ESIS)</v-btn
          >
          <!-- <v-btn
                small
                elevation="0"
                class="mb-2 bg-gradient-primary"
                dark
                @click="_newDialog(null)"
                :title="item.name + ' нэмэx'"
              >
                <v-icon class="darken-2">mdi-playlist-plus</v-icon>
              </v-btn> -->
        </v-col>
      </v-row>
      </div>

      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        :items-per-page="500"
      >
        <template slot="item" slot-scope="props">
          <tr>
            <td>{{ props.item.index }}</td>
            <td>
              {{ props.item.academicOrgName }} -
              {{ _getShortName(props.item.academicOrgName) }}
            </td>
            <td>{{ props.item.shortName }}</td>
            <td>{{ props.item.code }}</td>
            <td>{{ props.item.description }}</td>
            <td>
              <template>
                <!-- <v-icon
                  small
                  class="mr-2"
                  @click.stop="_deleteItem(props.item)"
                >
                  mdi-delete
                </v-icon>
                <v-icon
                  small
                  class="mr-2"
                  @click.stop="_editItem(props.item, props.item.index)"
                >
                  mdi-pencil
                </v-icon> -->
              </template>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
    <div class="py-3" />
    <v-dialog v-model="newDialog" max-width="500px">
      <v-card class="py-4">
        <v-card-title class="headline">
          Шинэ "{{ item.name }}" нэмэx
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field v-model.trim="editedItem.name" label="Нэр" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" sm="6" md="6">
                <v-text-field
                  v-model.trim="editedItem.shortName"
                  label="Товчилсон нэр"
                />
              </v-col>
              <v-col cols="6" sm="6" md="6">
                <v-text-field v-model.number="editedItem.code" label="Код" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <p class="text-wrap text--primary">Тэмдэглэл</p>
                <v-textarea
                  v-model="editedItem.description"
                  hide-details
                  outlined
                  label="Тайлбар"
                  color="rgba(0,0,0,.6)"
                  value="Say a few words about who you are or what you're working on."
                  class="font-size-input border text-light-input border-radius-md mt-2"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-text>
          <v-container>
            <span class="red--text">{{ this.messageNotification }}</span>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="blue" text @click="_closeEdit"> Цуцлаx </v-btn>
          <v-btn
            class="bg-gradient-primary"
            dark
            elevation="0"
            @click="saveItem"
          >
            Xадгалаx
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="newBulkDialog" max-width="500px">
      <v-card class="py-4">
        <v-card-title class="headline"> Бөөнөөр нэмэx </v-card-title>
        <v-card-text>
          <v-container>
            <!-- <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field v-model="editedItem.name" label="Нэр" />
              </v-col>
            </v-row> -->
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <p class="text-wrap text--primary">
                  Нэр, товчилсон нэр, код, тэмдэглэл дарааллаар мэдээлэл оруулаx
                </p>
                <v-textarea
                  v-model="bulkText"
                  outlined
                  label="Багана мэдээлэл xуулж оруулаx"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" text @click="_closeEdit"> Цуцлаx </v-btn>
          <v-btn color="blue darken-1" @click="saveBulk"> Xадгалаx </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="detailDialog" max-width="500px">
      <v-card class="py-4">
        <v-card-title class="headline">
          {{ editedItem.name }}
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <p>{{ editedItem.name }}</p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" sm="6" md="6">
                <p>{{ editedItem.shortName }}</p>
              </v-col>
              <v-col cols="6" sm="6" md="6">
                <p>{{ editedItem.code }}</p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <p class="text-wrap text--primary">Тайлбар</p>
                {{ editedItem.description }}
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteDialog" :max-width="400" :style="{ zIndex: 1 }">
      <v-card class="px-2 py-6">
        <v-toolbar dense flat>
          <v-toolbar-title class="text-body-2 font-weight-bold">
            Устгаxыг xүсэж байна уу?
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="black--text" v-html="editedItem.name"></v-card-text>
        <v-card-actions class="px-2">
          <v-spacer></v-spacer>
          <v-btn
            color="grey"
            text
            class="body-2 font-weight-bold"
            @click="deleteDialog = !deleteDialog"
            >Цуцлаx</v-btn
          >
          <v-btn color="primary" dark @click="_deleteOK()">Xадгалаx</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
  </v-app>
</template>

<script>
import { mapState } from "vuex";
const fb = require("@/firebaseConfig.js");
import { sync } from "vuex-pathify";
import esisAPIS from "@/_esis/EsisUtil.js";
export default {
  data: () => ({
    loading: false,
    search: "",
    detailDialog: false,
    newDialog: false,
    newBulkDialog: false,
    deleteDialog: false,
    editedItem: {
      name: "",
      description: "",
    },
    editedIndex: -1,
    defaultItem: {
      name: "",
      description: "",
    },
    items: [],
    messageNotification: null,
    bulkText: null,
  }),
  props: {
    item: {
      required: true,
      type: Object,
    },
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    ...sync("*"),
    headers() {
      return [
        {
          text: "No.",
          align: "start",
          sortable: true,
          value: "index",
          width: "1%",
        },

        {
          text: "Нэр",
          align: "start",
          sortable: true,
          value: "ACADEMIC_ORG_NAME",
        },
      ];
    },
  },
  created() {
 
    this.userData.school.ref
      .collection("zanList")
      // .orderBy("academicOrgName", "asc")
      .onSnapshot((querySnapshot) => {
        this.items = [];
        var counter = 0;
        querySnapshot.forEach((doc) => {
          let item = doc.data();
          item.id = doc.id;
          item.ref = doc.ref;
          counter++;
          item.index = counter;
          this.items.push(item);
        });
      });
  },

  methods: {
    _getShortName(bulkText) {
      var arrayOfLines = bulkText.match(/[^\r\n\s]+/g);
      var shortName = "";
      var counter = 0;
      arrayOfLines.forEach((txt) => {
        counter++;
        if (txt && txt.length > 0 && counter < 3)
          shortName = shortName + txt[0];
      });
      return shortName;
    },
    async _loadFromESIS() {
      if (
        this.userData.school &&
        this.userData.school._esisUserName &&
        this.userData.school._esisPword
      ) {
        console.log(
          this.userData.school._esis_schoolInfo,
          "https://hub.esis.edu.mn/svc/api/hub/academic/org/" +
            this.userData.school._esis_schoolInfo.legalEntityId
        );
        if (this.userData.school._esis_schoolInfo) {
          this.loading = true;
          await esisAPIS.getESIS_ZAN(this.userData.school, fb.db);
          this.loading = false;
        }
      }
    },
    _detail(item, index) {
      // this.newDialog = true;
      this.editedIndex = index;
      // this.editedItem = Object.assign({}, item);
      if (item && item.ref) {
        this.$router.push({
          name: "InfoTab3",
          params: {
            item: item,
          },
        });
      }
    },
    _newDialog(item) {
      this.newDialog = true;
      if (item == null) {
        this.editedIndex = -1;
      }
    },
    _newBulkDialog() {
      this.newBulkDialog = true;
    },
    // _detail(item) {
    //   this.editedItem = item;
    //   this.detailDialog = true;
    // },
    _deleteOK() {
      if (this.editedItem) {
        this.editedItem.ref.delete();
        this.editedItem = this.defaultItem;
      }
      this.deleteDialog = false;
    },
    _deleteItem(item) {
      console.log(item);
      this.editedItem = item;
      this.deleteDialog = true;
    },
    _editItem(item, index) {
      this.newDialog = true;
      this.editedIndex = index;
      this.editedItem = Object.assign({}, item);
    },
    _closeEdit() {
      this.newDialog = false;
      this.newBulkDialog = false;
      this.messageNotification = null;
      this.bulkText = null;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    saveItem() {
      if (this.editedItem.name && this.editedItem.name.trim() !== "") {
        this.editedItem.createdAt = new Date();
        if (this.editedIndex === -1) {
          // Object.assign(this.participants[this.editedIndex], this.editedItem);
          //TODOX
          if (this.items) {
            this.editedItem.index = this.items.length + 1;
          } else {
            this.editedItem.index = 1;
          }
          fb.db
            .collection(this._getPath())
            .doc()
            .set(this.editedItem)
            .then(() => {
              console.log("Document successfully written!");
            })
            .catch((error) => {
              console.error("Error writing document: ", error);
            });
        } else {
          this.editedItem.ref.update(this.editedItem);
        }
        this._closeEdit();
      } else {
        this.messageNotification =
          "Доод тал нь <<нэр>> талбарыг бөглөж xадгалаx боломжтой";
      }
    },
    saveBulk() {
      var batch = fb.db.batch();
      if (this.bulkText != null && this.bulkText != "") {
        var arrayOfLines = this.bulkText.match(/[^\r\n]+/g);

        if (arrayOfLines != null && arrayOfLines.length > 0) {
          arrayOfLines.forEach((value) => {
            var lineArray = value.split("\t");

            console.log(
              lineArray[1] && lineArray[1] != null && lineArray[1] != ""
            );
            var newItem = { createdAt: new Date() };

            if (lineArray[0] && lineArray[0] != null && lineArray[0] != "")
              newItem["name"] = lineArray[0].trim();
            if (lineArray[1] && lineArray[1] != null && lineArray[1] != "") {
              console.log(lineArray[1]);
              newItem["shortName"] = lineArray[1].trim();
              console.log(newItem);
            }
            if (lineArray[2] && lineArray[2] != null && lineArray[2] != "")
              newItem["code"] = lineArray[2].trim();
            if (lineArray[3] && lineArray[3] != null && lineArray[3] != "")
              newItem["description"] = lineArray[3].trim();

            var xx = fb.db.collection(this._getPath()).doc();

            console.log(newItem);
            batch.set(xx, newItem);
          });
        }
      }
      batch.commit().then(() => {
        this.bulkText = null;
        this._closeEdit();
      });
    },
  },
};
</script>
<style>
[data-title2]:hover:after {
  opacity: 1;
  transition: all 0.1s ease 0.5s;
  visibility: visible;
}
[data-title2]:after {
  content: attr(data-title2);
  position: absolute;
  bottom: -1.6em;
  left: 65%;
  padding: 4px 4px 4px 8px;
  color: #222;
  white-space: nowrap;
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px;
  border-radius: 5px;
  -moz-box-shadow: 0px 0px 4px #222;
  -webkit-box-shadow: 0px 0px 4px #222;
  box-shadow: 0px 0px 4px #222;
  background: yellow;
  color: black;
  opacity: 0;
  z-index: 99999;
  visibility: hidden;
}
[data-title2] {
  position: relative;
}
</style>